module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-autocomplete', {
    ref: "bauto",
    attrs: {
      "icon": "search",
      "icon-pack": "fa",
      "data": _vm.datasource,
      "placeholder": _vm.placeholder,
      "field": _vm.datafield,
      "keep-first": _vm.keepFirst,
      "expanded": ""
    },
    on: {
      "typing": _vm.ontyping,
      "select": function (option) { return _vm.selectWrapper(option); }
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onenter($event)
      }
    },
    model: {
      value: (_vm.inputVal),
      callback: function($$v) {
        _vm.inputVal = $$v
      },
      expression: "inputVal"
    }
  }, [(_vm.shownoresultstext) ? _c('template', {
    slot: "empty"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.noresultstext) + "\n\t\t\t\t")]) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-select', {
    staticClass: "is-hidden-tablet ",
    attrs: {
      "expanded": ""
    },
    on: {
      "input": _vm.updateAutocomplete
    },
    model: {
      value: (_vm.searchoptionspicked),
      callback: function($$v) {
        _vm.searchoptionspicked = $$v
      },
      expression: "searchoptionspicked"
    }
  }, _vm._l((_vm.SearchOptions), function(d) {
    return _c('option', {
      domProps: {
        "value": d.value
      }
    }, [_vm._v(_vm._s(d.name))])
  }), 0)], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-select', {
    staticClass: "is-hidden-mobile",
    attrs: {
      "expanded": ""
    },
    on: {
      "input": _vm.updateAutocomplete
    },
    model: {
      value: (_vm.searchoptionspicked),
      callback: function($$v) {
        _vm.searchoptionspicked = $$v
      },
      expression: "searchoptionspicked"
    }
  }, _vm._l((_vm.SearchOptions), function(d) {
    return _c('option', {
      domProps: {
        "value": d.value
      }
    }, [_vm._v(_vm._s(d.name))])
  }), 0)], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info is-hidden-mobile ",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.searchtext))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-hidden-mobile ",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(_vm._s(_vm.cleartext))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0694c58f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RxeobDrugSearchAutocomplete.vue
// module id = 511
// module chunks = 5